/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import * as S from '../../styles';

export interface IEmailInputProps {
    id: string;
    fontScale?: number;

    label?: string;
    labelColor?: string;
    errorText?: string;
    readOnly?: boolean;
    value?: string;
    required?: boolean;
    placeholder?: string;
    hasError?: boolean;
    onCompChange?(id: string, payload: any): void;
}

export const EmailInput = ({
    id,
    fontScale,

    label,
    labelColor,
    errorText,
    value,
    required,
    readOnly,
    placeholder,
    onCompChange,
    hasError,
}: IEmailInputProps) => {
    const [textValue, setTextValue] = useState(value ?? '');
    const [isInvalid, setInvalid] = useState(false);
    useEffect(() => setTextValue(value ?? ''), [value]);

    useEffect(() => {
        setInvalid(hasError);
    }, [hasError]);

    const onChange = (id: string, e: any) => {
        setTextValue(e?.target?.value.toLowerCase());
        onCompChange && onCompChange(id, e?.target?.value.toLowerCase());
    };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    document.getElementById(`input-${id}`)?.addEventListener('focusin', (e) => {
        console.log(e, 'moi->');
        document
            .getElementById(`input-group-${id}`)
            ?.classList.add('input-group-ch');
    });
    document
        .getElementById(`input-${id}`)
        ?.addEventListener('focusout', (e) => {
            console.log(e, 'moi->');
            document
                .getElementById(`input-group-${id}`)
                ?.classList.remove('input-group-ch');
        });

    return (
        <>
            <Form.Group
                id={id}
                className="formgroup"
                style={{ backgroundColor: readOnly ? '#F5F5F5' : '#fff' }}
            >
                {_renderLabelIf()}
                <InputGroup id={`input-group-${id}`} className="input-group-bt">
                    <S.FormControl
                        fontScale={fontScale}
                        id={`input-${id}`}
                        className="formcontrol shadow-none"
                        value={textValue}
                        onChange={onChange.bind(null, id)}
                        required={required}
                        type="email"
                        placeholder={placeholder}
                        readOnly={readOnly}
                        isInvalid={isInvalid}
                        style={{
                            backgroundColor: readOnly ? '#F5F5F5' : '#fff',
                        }}
                    />
                </InputGroup>
                <InputGroup>{_renderErrorTextIf()}</InputGroup>
            </Form.Group>
        </>
    );
};

EmailInput.defaultProps = {
    required: false,
    readOnly: false,
    hasError: false,
};
